import type { ActivityEntry } from '../types/api';

export function localDateKey(date = new Date()): string {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function dateFromKey(key: string): Date {
  const [year, month, day] = key.split('-').map(Number);
  return new Date(year, month - 1, day, 12);
}

export function shiftDate(date: Date, days: number): Date {
  const shifted = new Date(date);
  shifted.setDate(shifted.getDate() + days);
  return shifted;
}

export function startOfWeek(date: Date): Date {
  return shiftDate(date, -((date.getDay() + 6) % 7));
}

export function sumActivity(
  activity: Map<string, ActivityEntry>,
  start: Date,
  end: Date
): { activeSeconds: number; attempts: number } {
  let activeSeconds = 0;
  let attempts = 0;
  for (let cursor = new Date(start); cursor <= end; cursor = shiftDate(cursor, 1)) {
    const entry = activity.get(localDateKey(cursor));
    activeSeconds += entry?.activeSeconds ?? 0;
    attempts += entry?.attempts ?? 0;
  }
  return { activeSeconds, attempts };
}

export function formatActiveTime(seconds: number): string {
  if (seconds <= 0) return '0 min';
  const minutes = Math.floor(seconds / 60);
  if (minutes < 1) return '< 1 min';
  const hours = Math.floor(minutes / 60);
  const remainder = minutes % 60;
  if (!hours) return `${minutes} min`;
  return remainder ? `${hours} t ${remainder} min` : `${hours} t`;
}

export function isoWeekNumber(date: Date): number {
  const target = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
  const day = target.getUTCDay() || 7;
  target.setUTCDate(target.getUTCDate() + 4 - day);
  const yearStart = new Date(Date.UTC(target.getUTCFullYear(), 0, 1));
  return Math.ceil((((target.getTime() - yearStart.getTime()) / 86400000) + 1) / 7);
}
